<oui-textarea
  class="width-100pc"
  label="Commentaire (facultatif)"
  placeholder="Commentaire (facultatif)"
  [control]="control"></oui-textarea>
